<h2 mat-dialog-title>Confirm help contact delete</h2>
<div mat-dialog-content class="mat-typography">
 <p>Are you sure you want to delete the {{ data.contactName }} contact?</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button [mat-dialog-close]="true">DELETE</button>
</div>
